var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXlsDocumentLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xls-document-logo_svg__clip0_205_28373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.616 22.674l-15.814-2.79v20.62c0 .942.764 1.705 1.705 1.705h27.288c.941 0 1.705-.763 1.705-1.705v-7.597L29.616 22.675z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.616 5H15.507c-.941 0-1.705.763-1.705 1.705v7.597l15.814 9.303 8.372 2.79 6.512-2.79v-9.303L29.616 5z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.802 14.302h15.814v9.303H13.802v-9.303z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.12 12.442H13.802v23.256H25.12a1.71 1.71 0 001.706-1.705V14.147a1.71 1.71 0 00-1.706-1.705z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.19 13.372H13.802v23.256H24.19a1.71 1.71 0 001.705-1.705V15.077a1.71 1.71 0 00-1.705-1.705z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.19 13.372H13.802v21.395H24.19a1.71 1.71 0 001.705-1.705V15.077a1.71 1.71 0 00-1.705-1.705z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.26 13.372h-9.458v21.395h9.458a1.71 1.71 0 001.705-1.705V15.077a1.71 1.71 0 00-1.705-1.705z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.205 13.372H23.26c.942 0 1.705.764 1.705 1.705v17.055c0 .942-.763 1.705-1.705 1.705H6.205A1.705 1.705 0 014.5 32.132V15.077c0-.941.763-1.705 1.705-1.705z",
    fill: "url(#xls-document-logo_svg__paint0_linear_205_28373)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.781 29.147l3.587-5.558-3.287-5.527h2.644l1.794 3.534a9.1 9.1 0 01.34.75h.023c.118-.268.242-.528.373-.78l1.917-3.503h2.427l-3.37 5.495 3.455 5.59h-2.582l-2.072-3.88a3.251 3.251 0 01-.247-.519h-.03c-.062.176-.142.345-.24.502l-2.134 3.896H9.781z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.795 5H29.616v9.302H44.5V6.705C44.5 5.763 43.736 5 42.795 5z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.616 23.605H44.5v9.302H29.616v-9.302z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "xls-document-logo_svg__paint0_linear_205_28373",
    x1: 8.055,
    y1: 12.04,
    x2: 21.41,
    y2: 35.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xls-document-logo_svg__clip0_205_28373"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4.5 5)",
    d: "M0 0h40v37.209H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/xls-document-logo.573473891d0ba15ada987fe6db5fb36b.svg";
export { SvgXlsDocumentLogo as ReactComponent };